
import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Alert, Col } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";

interface IProps {
    submitError: any
}

const ErrorsList: React.FC<IProps> = ({ submitError}) => {

const [t] = useTranslation(["translation",  "errors"], translationHookOptions);
 

  
    return (
    <Alert color="danger" className="w-100">
    {submitError.data  && submitError.data.errors ? (
     Array.isArray(submitError.data.errors) ? (
      <ul style={{ textAlign: "left" , paddingLeft:"3%"}}>
        {submitError.data.errors
          .map((error: any) => error.errorCode)
          .map((errorCode: any, index: any) => (
            <li key={index} >
              {t(errorCode, { ns: "errors" })}
            </li>
          ))}
      </ul>
      ) : (
<ul style={{ textAlign: "left", paddingLeft: "3%" }}>
  {Object.entries(submitError?.data?.errors || {})
    .filter(([key]) => key === "code")
    .map(([_, value], i) => (
      <li key={i} style={{ marginTop: "3%" }}>
        {t(`${value}`, { ns: "errors" })}
      </li>
    ))}
</ul>
      )
    ) : null}
   </Alert>
  );
};

export default ErrorsList;
